/**
 * Origem Flow: serviço das aprovações por link (/api/approvals/*).
 * Os endpoints public* não exigem autenticação — são a página do cliente.
 */
export default (client) => {
  return {
    fetchAll(tableId, rowId) {
      return client.get(`/approvals/table/${tableId}/row/${rowId}/`)
    },
    create(tableId, rowId, values) {
      return client.post(`/approvals/table/${tableId}/row/${rowId}/`, values)
    },
    contacts(tableId) {
      return client.get(`/approvals/contacts/${tableId}/`)
    },
    update(approvalId, values) {
      return client.patch(`/approvals/${approvalId}/`, values)
    },
    addRound(approvalId, { note, files }) {
      return client.post(`/approvals/${approvalId}/versions/`, { note, files })
    },
    manualDecision(approvalId, values) {
      return client.post(`/approvals/${approvalId}/manual-decision/`, values)
    },
    sendEmail(approvalId, to) {
      return client.post(`/approvals/${approvalId}/send-email/`, { to })
    },
    // Pendências do cliente (/api/checklists/*).
    fetchChecklists(tableId, rowId) {
      return client.get(`/checklists/table/${tableId}/row/${rowId}/`)
    },
    createChecklist(tableId, rowId, values) {
      return client.post(`/checklists/table/${tableId}/row/${rowId}/`, values)
    },
    updateChecklist(checklistId, values) {
      return client.patch(`/checklists/${checklistId}/`, values)
    },
    resolveChecklistItem(checklistId, itemId, values) {
      return client.patch(`/checklists/${checklistId}/items/${itemId}/`, values)
    },
    ensureRequestForm(tableId) {
      return client.post(`/checklists/table/${tableId}/request-form/`)
    },
    publicChecklistGet(token) {
      return client.get(`/checklists/public/${token}/`)
    },
    publicChecklistUpload(token, file) {
      const formData = new FormData()
      formData.append('file', file)
      return client.post(`/checklists/public/${token}/upload/`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
    },
    publicChecklistResolve(token, itemId, values) {
      return client.post(`/checklists/public/${token}/items/${itemId}/`, values)
    },
    // Resumo da semana por espaço (/api/digests/*).
    fetchDigests(databaseId) {
      return client.get(`/digests/database/${databaseId}/`)
    },
    previewDigest(databaseId, values) {
      return client.post(`/digests/database/${databaseId}/preview/`, values)
    },
    createDigest(databaseId, values) {
      return client.post(`/digests/database/${databaseId}/`, values)
    },
    fetchTableDigests(tableId) {
      return client.get(`/digests/table/${tableId}/`)
    },
    previewTableDigest(tableId, values) {
      return client.post(`/digests/table/${tableId}/preview/`, values)
    },
    createTableDigest(tableId, values) {
      return client.post(`/digests/table/${tableId}/`, values)
    },
    updateDigest(digestId, values) {
      return client.patch(`/digests/${digestId}/`, values)
    },
    sendDigestEmail(digestId, to) {
      return client.post(`/digests/${digestId}/send-email/`, { to })
    },
    publicDigestGet(token) {
      return client.get(`/digests/public/${token}/`)
    },
    publicDigestRate(token, values) {
      return client.post(`/digests/public/${token}/rating/`, values)
    },
    // Avaliação do cliente / NPS (/api/ratings/*).
    fetchRatings(tableId, rowId) {
      return client.get(`/ratings/table/${tableId}/row/${rowId}/`)
    },
    createRating(tableId, rowId, values) {
      return client.post(`/ratings/table/${tableId}/row/${rowId}/`, values)
    },
    updateRating(ratingId, values) {
      return client.patch(`/ratings/${ratingId}/`, values)
    },
    sendRatingEmail(ratingId, to) {
      return client.post(`/ratings/${ratingId}/send-email/`, { to })
    },
    fetchNps(databaseId) {
      return client.get(`/ratings/database/${databaseId}/nps/`)
    },
    publicRatingGet(token) {
      return client.get(`/ratings/public/${token}/`)
    },
    publicRatingAnswer(token, values) {
      return client.post(`/ratings/public/${token}/answer/`, values)
    },
    publicGet(token) {
      return client.get(`/approvals/public/${token}/`)
    },
    publicAnnotate(token, values) {
      return client.post(`/approvals/public/${token}/annotations/`, values)
    },
    publicDecide(token, values) {
      return client.post(`/approvals/public/${token}/decision/`, values)
    },
  }
}
